import React from 'react';
import {
  Popover as PopoverComponent,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverFooter,
  PopoverTrigger,
  UsePopperProps,
  Box,
} from '@chakra-ui/react';
import s from './Popover.module.scss';

interface PopoverProps extends UsePopperProps {
  bodyChildren: string | JSX.Element;
  footerChildren?: string | JSX.Element;
  triggerIcon?: JSX.Element;
  useContextMenu?: boolean;
}

export const Popover = ({
  bodyChildren,
  footerChildren,
  triggerIcon,
  useContextMenu,
  ...rest
}: PopoverProps): JSX.Element => {
  return (
    <PopoverComponent {...rest}>
      <PopoverTrigger>
        {useContextMenu ? (
          <Box float="right">
            <button className={s.button}>
              <div className={s.dots} />
            </button>
          </Box>
        ) : (
          triggerIcon
        )}
      </PopoverTrigger>
      <PopoverContent
        p={4}
        width="100%"
        color="black"
        bg="bg-default"
        borderColor="bg-default"
        boxShadow=" 0 1px 3px 0 rgba(0, 0, 0, 0.06), 0 8px 20px 0 rgba(0, 0, 0, 0.15)"
      >
        <PopoverArrow
          bg="white"
          sx={{ '--popper-arrow-shadow-color': 'white' }}
        />
        <PopoverBody>{bodyChildren}</PopoverBody>
        {footerChildren && (
          <PopoverFooter border="0" display="flex">
            {footerChildren}
          </PopoverFooter>
        )}
      </PopoverContent>
    </PopoverComponent>
  );
};
